import axios from "axios";
import React,{ useState, useEffect, useRef } from "react";
import { ArrowLeft, Plus, X } from 'react-feather';
import Sidebar from './sidebar';
import { Link } from "react-router-dom";
import api from "../api";
import { fetchExchangeRates } from "../exchangeRateService";

function AddProduct() {    
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const VendorId = localStorage.getItem('vendor_id');
    const [errorMsg, setErrorMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const [CategoryData, setCategoryData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedCurrency, setSelectedCurrency] = useState("");
    const [ProductData, setProductData] = useState({
        "vendor": '',
        "category": '',
        "title": '',
        "slug": '',
        "detail": '',
        "offer_price": 0,
        "price": '',
        "usd_price": '',
        "keywords": '',
        "gender": '',
        "image": '',
        "visits": '',
        "status": '',
        "currency":'',
    });
    const [ProductImgs, setProductImgs] = useState([]);
    const [inputFields, setInputFields] = useState([["", ""]]);
    const token = localStorage.getItem("access_token");

    // Reference to the div with id="image_preview1"
    const imagePreviewRef = useRef(null);

    useEffect(() => {
        setProductData({
            ...ProductData,
            'vendor': VendorId
        });
        fetchData(baseUrl + '/categories/');
         // Retrieve customer data from localStorage when the component mounts
        const storedCurrency = localStorage.getItem('baseCurrency');
        if (storedCurrency === null) {
            // Fetch user's country and set default currency
            fetch("https://ipapi.co/json/")
                .then((res) => res.json())
                .then((data) => {
                const currency = getCurrencyByCountry(data.country_code);
                const country = data.country_name;
        
                fetchExchangeRates(currency);
    
                const currencyData = { currency, country };
                localStorage.setItem("selectedCurrency", JSON.stringify(currencyData));
                localStorage.setItem("baseCurrency", currency);
            
                setSelectedCurrency(currency);
                })
                .catch(//(err) => console.error("Error fetching location:", err)
                )
                .finally(() => setLoading(false));
        }
        const getCurrencyByCountry = (countryCode) => {
        const currencyMap = {
            AF: 'AFN', // Afghanistan
            AL: 'ALL', // Albania
            DZ: 'DZD', // Algeria
            AD: 'EUR', // Andorra
            AO: 'AOA', // Angola
            AR: 'ARS', // Argentina
            AM: 'AMD', // Armenia
            AU: 'AUD', // Australia
            AT: 'EUR', // Austria
            AZ: 'AZN', // Azerbaijan
            BH: 'BHD', // Bahrain
            BD: 'BDT', // Bangladesh
            BY: 'BYN', // Belarus
            BE: 'EUR', // Belgium
            BZ: 'BZD', // Belize
            BJ: 'XOF', // Benin
            BT: 'BTN', // Bhutan
            BO: 'BOB', // Bolivia
            BA: 'BAM', // Bosnia and Herzegovina
            BW: 'BWP', // Botswana
            BR: 'BRL', // Brazil
            BN: 'BND', // Brunei
            BG: 'BGN', // Bulgaria
            BF: 'XOF', // Burkina Faso
            BI: 'BIF', // Burundi
            KH: 'KHR', // Cambodia
            CM: 'XAF', // Cameroon
            CA: 'CAD', // Canada
            CV: 'CVE', // Cape Verde
            CL: 'CLP', // Chile
            CN: 'CNY', // China
            CO: 'COP', // Colombia
            KM: 'KMF', // Comoros
            CG: 'XAF', // Congo (Republic)
            CD: 'CDF', // Congo (DR)
            CR: 'CRC', // Costa Rica
            HR: 'HRK', // Croatia
            CU: 'CUP', // Cuba
            CY: 'EUR', // Cyprus
            CZ: 'CZK', // Czech Republic
            DK: 'DKK', // Denmark
            DJ: 'DJF', // Djibouti
            DO: 'DOP', // Dominican Republic
            EG: 'EGP', // Egypt
            SV: 'SVC', // El Salvador
            EE: 'EUR', // Estonia
            ET: 'ETB', // Ethiopia
            FI: 'EUR', // Finland
            FR: 'EUR', // France
            GA: 'XAF', // Gabon
            GM: 'GMD', // Gambia
            GE: 'GEL', // Georgia
            DE: 'EUR', // Germany
            GH: 'GHS', // Ghana
            GR: 'EUR', // Greece
            GT: 'GTQ', // Guatemala
            GN: 'GNF', // Guinea
            GW: 'XOF', // Guinea-Bissau
            GY: 'GYD', // Guyana
            HT: 'HTG', // Haiti
            HN: 'HNL', // Honduras
            HK: 'HKD', // Hong Kong
            HU: 'HUF', // Hungary
            IS: 'ISK', // Iceland
            IN: 'INR', // India
            ID: 'IDR', // Indonesia
            IR: 'IRR', // Iran
            IQ: 'IQD', // Iraq
            IE: 'EUR', // Ireland
            IL: 'ILS', // Israel
            IT: 'EUR', // Italy
            JM: 'JMD', // Jamaica
            JP: 'JPY', // Japan
            JO: 'JOD', // Jordan
            KZ: 'KZT', // Kazakhstan
            KE: 'KES', // Kenya
            KW: 'KWD', // Kuwait
            KG: 'KGS', // Kyrgyzstan
            LA: 'LAK', // Laos
            LV: 'EUR', // Latvia
            LB: 'LBP', // Lebanon
            LS: 'LSL', // Lesotho
            LR: 'LRD', // Liberia
            LY: 'LYD', // Libya
            LT: 'EUR', // Lithuania
            LU: 'EUR', // Luxembourg
            MG: 'MGA', // Madagascar
            MW: 'MWK', // Malawi
            MY: 'MYR', // Malaysia
            MV: 'MVR', // Maldives
            ML: 'XOF', // Mali
            MT: 'EUR', // Malta
            MX: 'MXN', // Mexico
            MD: 'MDL', // Moldova
            MN: 'MNT', // Mongolia
            MA: 'MAD', // Morocco
            MZ: 'MZN', // Mozambique
            MM: 'MMK', // Myanmar
            NA: 'NAD', // Namibia
            NP: 'NPR', // Nepal
            NL: 'EUR', // Netherlands
            NZ: 'NZD', // New Zealand
            NI: 'NIO', // Nicaragua
            NE: 'XOF', // Niger
            NG: 'NGN', // Nigeria
            NO: 'NOK', // Norway
            OM: 'OMR', // Oman
            PK: 'PKR', // Pakistan
            PG: 'PGK', // Papua New Guinea
            PY: 'PYG', // Paraguay
            PE: 'PEN', // Peru
            PH: 'PHP', // Philippines
            PL: 'PLN', // Poland
            PT: 'EUR', // Portugal
            QA: 'QAR', // Qatar
            RO: 'RON', // Romania
            RU: 'RUB', // Russia
            RW: 'RWF', // Rwanda
            SA: 'SAR', // Saudi Arabia
            SN: 'XOF', // Senegal
            RS: 'RSD', // Serbia
            SC: 'SCR', // Seychelles
            SL: 'SLL', // Sierra Leone
            SG: 'SGD', // Singapore
            SK: 'EUR', // Slovakia
            SI: 'EUR', // Slovenia
            ZA: 'ZAR', // South Africa
            ES: 'EUR', // Spain
            LK: 'LKR', // Sri Lanka
            SD: 'SDG', // Sudan
            SR: 'SRD', // Suriname
            SZ: 'SZL', // Eswatini
            SE: 'SEK', // Sweden
            CH: 'CHF', // Switzerland
            SY: 'SYP', // Syria
            TW: 'TWD', // Taiwan
            TZ: 'TZS', // Tanzania
            TH: 'THB', // Thailand
            TG: 'XOF', // Togo
            TO: 'TOP', // Tonga
            TN: 'TND', // Tunisia
            TR: 'TRY', // Turkey
            UG: 'UGX', // Uganda
            UA: 'UAH', // Ukraine
            AE: 'AED', // United Arab Emirates
            GB: 'GBP', // United Kingdom
            US: 'USD', // United States
            UY: 'UYU', // Uruguay
            UZ: 'UZS', // Uzbekistan
            VE: 'VES', // Venezuela
            VN: 'VND', // Vietnam
            YE: 'YER', // Yemen
            ZM: 'ZMW', // Zambia
            ZW: 'ZWL'  // Zimbabwe
            };
        ;
        return currencyMap[countryCode] || 'KES'; // Default to USD if country not found
        };
    }, []);

    function fetchData(baseurl) {
        fetch(baseurl)
            .then((response) => response.json())
            .then((data) => {
                setCategoryData(data.results);
            });
    }

    const inputHandler = (event) => {
        setProductData({
            ...ProductData,
            [event.target.name]: event.target.value
        });
    };

    const multipleFilesHandler = (event) => {
        const files = Array.from(event.target.files);
        if (files.length > 0) {
          setProductImgs(files);
      
          const previewContainer = imagePreviewRef.current;
          previewContainer.innerHTML = ''; // clear old previews
          files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = (e) => {
              const img = document.createElement('img');
              img.src = e.target.result;
              img.style.width = '70px';
              img.style.margin = '5px';
              previewContainer.appendChild(img);
            };
            reader.readAsDataURL(file);
          });
        }
      };
      

    const addInputFields = () => {
        setInputFields([...inputFields, ["", ""]]);
    };

    const handleInputChange = (index, subIndex, event) => {
        const values = [...inputFields];
        values[index][subIndex] = event.target.value;
        setInputFields(values);
    };

    const removeInputFields = (index) => {
        const values = [...inputFields];
        values.splice(index, 1);
        setInputFields(values);
    };
    const submitHandler = async (event) => {
        setLoading(true);
        event.preventDefault();
        const allFieldsFilled = inputFields.every((pair) => pair[0] && pair[1]);
        
        if (!allFieldsFilled || !ProductImgs.length) {
            alert("Kindly fill out all fields and upload at least one image.");
            return;
        }

        const formData = new FormData();
        formData.append('vendor', VendorId);
        formData.append('category', ProductData.category);
        formData.append('title', ProductData.title);
        formData.append('slug', ProductData.title);
        formData.append('detail', ProductData.detail);
        formData.append('offer_price', ProductData.price);
        formData.append('price', ProductData.price);
        formData.append('usd_price', ProductData.usd_price);
        formData.append('keywords', ProductData.keywords);
        formData.append('gender', ProductData.gender);
        formData.append('visits', 0);
        formData.append('status', 1);
        formData.append('currency', selectedCurrency);

        try {
            const response = await api.post(baseUrl + '/products/', formData, {
                headers: { 'content-type': 'multipart/form-data',Authorization: `Bearer ${token}` }
            });

            if (response.status == 201) {
                const productId = response.data.id;
                
                const postData = inputFields.map(([size, qty]) => ({
                    product: productId,
                    size: size,
                    qty: qty
                }));

                await Promise.all(postData.map(row => axios.post(baseUrl + "/size/", row)));

                if (Array.isArray(ProductImgs)) {
                    await Promise.all(ProductImgs.map((img) => {
                        const ImgFormData = new FormData();
                        ImgFormData.append('product', productId);
                        ImgFormData.append('image', img);
                        return axios.post(baseUrl + '/product-imgs/', ImgFormData);
                    }));
                }
                setLoading(false);

                setSuccessMsg('Product Added Successfully');
                setErrorMsg('');
                setProductImgs([]);
                setProductData({
                    "vendor": '',
                    "category": '',
                    "title": '',
                    "slug": '',
                    "detail": '',
                    "price": '',
                    "offer_price": '',
                    "usd_price": '',
                    "keywords": '',
                    "gender": '',
                    "image": '',
                    "visits": '',
                    "status": '',
                    "currency": '',
                });
                setInputFields([["", ""]]);

                // Clear the contents of the image preview div
                if (imagePreviewRef.current) {
                    imagePreviewRef.current.innerHTML = ''; // Clear contents of image_preview1
                }
            } else {
                setLoading(false);
                setErrorMsg('There was a problem adding the product. Kindly try again.');
                setSuccessMsg('');
            }
        } catch (error) {
            setLoading(false);
            //console.error("Error during product submission:", error);
            setErrorMsg('An error occurred. Kindly try again.');
        }
    };

    const buttonEnable = ProductImgs.length > 0 && ProductData.category && ProductData.title && ProductData.price && ProductData.detail;


    return (
        <section className="container mtopcon dashb">
            <div className="row">
            <div className="col-12 col-lg-2 dash-min mb-3">
                    <div className="nav-left-sidebar sidebar-dark pc">
                        <div className="slimScrollDiv" ><div className="menu-list" >
                            <nav className="navbar navbar-expand-lg navbar-light nav-l-con">
                                <a className="d-xl-none d-lg-none" href="#"></a>
                                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                    <span className="navbar-toggler-icon"></span>
                                </button>
                                <div className="collapse navbar-collapse" id="navbarNav">
                                    <Sidebar/>
                                </div>
                            </nav>
                        </div><div className="slimScrollBar"></div><div className="slimScrollRail"></div></div>
                    </div>
                </div>
                <div className="col-12 col-lg-10 dash-max">
                    
                        <div className="row mb-3 ph-header-con">
                            <div className="col-7 pt-2"><h6 className="pageheader-title mb-3">Add New Product</h6></div>
                            <div className="col-5"><Link to="/seller/products"><button className="btn btn-primary f85 float-right"><ArrowLeft/></button></Link></div>
                        </div>
                    <div className="row">
                        <div className="col-12 col-lg-4">
                            <div className="card shadow-sm border border-secondary border-opacity-10">                               
                               
                                <div className="card-body">   
                                        <div className="row">
                                            <label className="form-label font9 mb-0">Select atleast 2 Product Images</label>
                                            <div className="upimgcon">
                                                <input
                                                    type="file"
                                                    name="images[]"
                                                    id="images1"
                                                    multiple
                                                    className="form-control opzero"
                                                    required
                                                    onChange={multipleFilesHandler}
                                                /> <button className="btn addimg"><Plus/> </button>
                                            </div>
                                            <div className="col-7 p-0 previewimg">
                                                <div id="image_preview1" ref={imagePreviewRef}>
                                                   
                                                </div>
                                            </div>
                                        </div>   
                                        
                                        <div className="mb-3">
                                            <label className="form-label font9 mb-0">Gender</label>
                                            <select className="form-control addprobginpt" name='gender' onChange={inputHandler} value={ProductData.gender}>
                                                    <option value="">Select</option>
                                                    <option value='Unisex'>Unisex</option>
                                                    <option value='Female'>Female</option>
                                                    <option value='Male'>Male</option>
                                            </select>
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label font9 mb-0">Category</label>
                                            <select className="form-control addprobginpt" name='category' onChange={inputHandler} value={ProductData.category}>
                                            <option value="">Select</option>
                                                {
                                                    CategoryData.map((item,index)=>{ 
                                                        return <option value={item.id} key={index}>{item.title}</option>
                                                    })
                                                }
                                            </select>
                                        </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-8">
                            <div className="card shadow-sm border border-secondary border-opacity-10">
                            
                                <div className="card-body">                        
                                    <form>
                                        <div className="row mb-3">
                                            <div className="col-12">
                                                <label className="form-label font9 mb-0">Product Name</label>
                                                <input type="text" onChange={inputHandler} value={ProductData.title} name="title"  className="form-control addprobginpt" id="fnm"/>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-12">
                                                <label className="form-label font9 mb-0">Price</label>
                                                <input type="number" onChange={inputHandler} value={ProductData.price} name="price" className="form-control addprobginpt" id="lnm"/>
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label font9 mb-0">Description</label>
                                            <textarea type="text" onChange={inputHandler} value={ProductData.detail} name="detail" className="form-control addprobginpt" id="lnm"/>
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label font9 mb-0">Stock & Size</label>
                                            <div className="row mb-0">
                                                <div className="col-5">
                                                    <label className="form-label font9 mb-0 grey-text">Size Name</label>
                                                </div>
                                                <div className="col-5">
                                                    <label className="form-label font9 mb-0 grey-text">Qty</label>
                                                </div>
                                            </div>

                                            {inputFields.map((pair, index) => (
                                                <div key={index} className="row mb-3">
                                                    <div className="col-5">
                                                        <input
                                                            type="text"
                                                            className="form-control addprobginpt w-100 size_mn"
                                                            value={pair[0]}
                                                            onChange={(event) => handleInputChange(index, 0, event)}
                                                            placeholder="XL, ml ,kg, Inches, Generic"
                                                        />
                                                    </div>
                                                    <div className="col-5">
                                                        <input
                                                            type="number"
                                                            className="form-control addprobginpt w-100 qty_mn"
                                                            value={pair[1]}
                                                            onChange={(event) => handleInputChange(index, 1, event)}
                                                            placeholder="1"
                                                        />
                                                    </div>
                                                    <div className="col-2">
                                                        <span onClick={() => removeInputFields(index)} style={{ marginLeft: "5px" }}>
                                                            <X/>
                                                        </span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div onClick={addInputFields} className="font9 pointer">
                                            + Add Size Variant
                                        </div>
                                        { loading === true ? <><button type="button" className="col-12 btn btn-primary mt-3">Loading...</button></> : <><button type="button" disabled={!buttonEnable} onClick={submitHandler} className="col-12 btn btn-primary mt-3">Add Product</button></>}
                                        
                                            
                                        {successMsg && <p className="text-success text-center mt-3"><b>{successMsg}</b></p> } 
                                        {errorMsg && <p className="text-danger text-center mt-3"><b>{errorMsg}</b></p> } 
                                        
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AddProduct;